// Libs
import { Outlet, ScrollRestoration } from 'react-router';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router';

// Components
import ErrorDisplay from '~fpu/shared/components/ErrorDisplay';
import RouteErrorElement from '~fpu/shared/components/RouteErrorElement';

// Routes
import CLASSES_ROUTES from './classes';
import DEBUG_ROUTES from '~fpu/modules/Debug/routes';
import MEMBER_DASHBOARD_ROUTES from '~fpu/modules/MemberDashboard/routes';
import ORGANIZATION_ROUTES from '~fpu/modules/Organizations/routes';
import SNAPSHOT_ROUTES from '~fpu/modules/Snapshot/routes';
import FPU_DASHBOARD_ROUTES from '~fpu/modules/FpuDashboard/routes';
import { PERMANENT_REDIRECTS } from './redirects';

const Root = () => {
  return (
    <>
      <ScrollRestoration />
      <div className="bg-gray-10 mx-auto h-full w-full">
        <Outlet />
      </div>
    </>
  );
};

const ErrorElement = () => (
  <RouteErrorElement>
    {(status) => <ErrorDisplay code={status} />}
  </RouteErrorElement>
);

const router = createBrowserRouter(
  [
    {
      element: <Root />,
      errorElement: <ErrorElement />,
      children: [
        ...PERMANENT_REDIRECTS, // Permanent redirects
        ...CLASSES_ROUTES, // /app/classes/*
        ...DEBUG_ROUTES, // /app/debug
        ...MEMBER_DASHBOARD_ROUTES, // /app/member/*
        ...ORGANIZATION_ROUTES, // /app/organization
        ...SNAPSHOT_ROUTES, // /app/snapshot (unauthenticated),
        ...FPU_DASHBOARD_ROUTES, // /app/dashboard
        {
          path: '*',
          element: <ErrorDisplay message="We can’t seem to find that page." />
        }
      ]
    }
  ],
  { basename: '/app' }
);

export { router };
